var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _g2, _g3, _circle, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraInstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 252,
    viewBox: "0 0 329 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_724_5524)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 288.455,
    height: 167,
    rx: 8,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 38.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 38.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 38.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238 20C238 17.7909 236.209 16 234 16H98C95.7909 16 94 17.7909 94 20V56C94 58.2091 92.2091 60 90 60H24C21.7909 60 20 61.7909 20 64V220C20 224.418 23.5817 228 28 228H300C304.418 228 308 224.418 308 220V64C308 61.7909 306.209 60 304 60H242C239.791 60 238 58.2091 238 56V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 131.5,
    x2: 308,
    y2: 131.5,
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.824 188.224C94.8533 188.224 93.9713 187.995 93.178 187.538C92.3847 187.081 91.7593 186.455 91.302 185.662C90.854 184.859 90.63 183.968 90.63 182.988C90.63 182.008 90.854 181.121 91.302 180.328C91.7593 179.525 92.3847 178.895 93.178 178.438C93.9713 177.981 94.8533 177.752 95.824 177.752C96.5707 177.752 97.252 177.897 97.868 178.186C98.4933 178.466 99.0347 178.867 99.492 179.39L98.638 180.216C98.2553 179.759 97.8353 179.423 97.378 179.208C96.93 178.993 96.412 178.886 95.824 178.886C95.096 178.886 94.4287 179.059 93.822 179.404C93.2153 179.74 92.73 180.221 92.366 180.846C92.0113 181.462 91.834 182.176 91.834 182.988C91.834 183.8 92.0113 184.519 92.366 185.144C92.73 185.76 93.2153 186.241 93.822 186.586C94.4287 186.922 95.096 187.09 95.824 187.09C97.0373 187.09 98.0687 186.591 98.918 185.592L99.786 186.432C99.3193 186.983 98.7453 187.421 98.064 187.748C97.3827 188.065 96.636 188.224 95.824 188.224ZM103.268 188.224C102.745 188.224 102.278 188.121 101.868 187.916C101.457 187.711 101.14 187.431 100.916 187.076C100.692 186.712 100.58 186.301 100.58 185.844C100.58 185.088 100.864 184.5 101.434 184.08C102.003 183.651 102.722 183.436 103.59 183.436C104.019 183.436 104.416 183.483 104.78 183.576C105.153 183.669 105.438 183.777 105.634 183.898V183.464C105.634 182.932 105.447 182.507 105.074 182.19C104.7 181.863 104.229 181.7 103.66 181.7C103.258 181.7 102.89 181.789 102.554 181.966C102.218 182.134 101.952 182.372 101.756 182.68L100.86 182.008C101.14 181.579 101.522 181.243 102.008 181C102.502 180.757 103.048 180.636 103.646 180.636C104.616 180.636 105.377 180.893 105.928 181.406C106.488 181.91 106.768 182.601 106.768 183.478V188H105.634V186.978H105.578C105.372 187.323 105.064 187.617 104.654 187.86C104.243 188.103 103.781 188.224 103.268 188.224ZM103.38 187.174C103.781 187.174 104.154 187.071 104.5 186.866C104.845 186.661 105.12 186.385 105.326 186.04C105.531 185.695 105.634 185.317 105.634 184.906C105.41 184.757 105.134 184.635 104.808 184.542C104.481 184.449 104.136 184.402 103.772 184.402C103.118 184.402 102.624 184.537 102.288 184.808C101.961 185.079 101.798 185.429 101.798 185.858C101.798 186.25 101.947 186.567 102.246 186.81C102.544 187.053 102.922 187.174 103.38 187.174ZM108.423 180.86H109.557V181.91H109.613C109.818 181.546 110.126 181.243 110.537 181C110.948 180.757 111.382 180.636 111.839 180.636C112.362 180.636 112.814 180.762 113.197 181.014C113.589 181.266 113.869 181.602 114.037 182.022C114.289 181.602 114.62 181.266 115.031 181.014C115.451 180.762 115.936 180.636 116.487 180.636C117.308 180.636 117.924 180.888 118.335 181.392C118.755 181.887 118.965 182.563 118.965 183.422V188H117.789V183.604C117.789 182.941 117.654 182.461 117.383 182.162C117.112 181.863 116.711 181.714 116.179 181.714C115.824 181.714 115.502 181.817 115.213 182.022C114.924 182.227 114.695 182.503 114.527 182.848C114.368 183.193 114.289 183.567 114.289 183.968V188H113.099V183.618C113.099 182.946 112.964 182.461 112.693 182.162C112.422 181.863 112.026 181.714 111.503 181.714C111.148 181.714 110.826 181.821 110.537 182.036C110.248 182.241 110.019 182.521 109.851 182.876C109.692 183.221 109.613 183.595 109.613 183.996V188H108.423V180.86ZM123.851 188.224C123.17 188.224 122.558 188.061 122.017 187.734C121.476 187.407 121.051 186.959 120.743 186.39C120.444 185.811 120.295 185.163 120.295 184.444C120.295 183.753 120.435 183.119 120.715 182.54C121.004 181.961 121.41 181.499 121.933 181.154C122.456 180.809 123.062 180.636 123.753 180.636C124.453 180.636 125.06 180.795 125.573 181.112C126.086 181.42 126.478 181.849 126.749 182.4C127.029 182.951 127.169 183.581 127.169 184.29C127.169 184.43 127.155 184.551 127.127 184.654H121.485C121.513 185.195 121.644 185.653 121.877 186.026C122.11 186.399 122.404 186.679 122.759 186.866C123.123 187.053 123.501 187.146 123.893 187.146C124.808 187.146 125.512 186.717 126.007 185.858L127.015 186.348C126.707 186.927 126.287 187.384 125.755 187.72C125.232 188.056 124.598 188.224 123.851 188.224ZM125.909 183.674C125.89 183.375 125.806 183.077 125.657 182.778C125.508 182.479 125.27 182.227 124.943 182.022C124.626 181.817 124.224 181.714 123.739 181.714C123.179 181.714 122.703 181.896 122.311 182.26C121.928 182.615 121.676 183.086 121.555 183.674H125.909ZM128.562 180.86H129.696V182.008H129.752C129.892 181.616 130.162 181.294 130.564 181.042C130.965 180.781 131.385 180.65 131.824 180.65C132.15 180.65 132.43 180.697 132.664 180.79V182.078C132.365 181.929 132.029 181.854 131.656 181.854C131.31 181.854 130.993 181.952 130.704 182.148C130.414 182.344 130.181 182.61 130.004 182.946C129.836 183.273 129.752 183.627 129.752 184.01V188H128.562V180.86ZM135.82 188.224C135.298 188.224 134.831 188.121 134.42 187.916C134.01 187.711 133.692 187.431 133.468 187.076C133.244 186.712 133.132 186.301 133.132 185.844C133.132 185.088 133.417 184.5 133.986 184.08C134.556 183.651 135.274 183.436 136.142 183.436C136.572 183.436 136.968 183.483 137.332 183.576C137.706 183.669 137.99 183.777 138.186 183.898V183.464C138.186 182.932 138 182.507 137.626 182.19C137.253 181.863 136.782 181.7 136.212 181.7C135.811 181.7 135.442 181.789 135.106 181.966C134.77 182.134 134.504 182.372 134.308 182.68L133.412 182.008C133.692 181.579 134.075 181.243 134.56 181C135.055 180.757 135.601 180.636 136.198 180.636C137.169 180.636 137.93 180.893 138.48 181.406C139.04 181.91 139.32 182.601 139.32 183.478V188H138.186V186.978H138.13C137.925 187.323 137.617 187.617 137.206 187.86C136.796 188.103 136.334 188.224 135.82 188.224ZM135.932 187.174C136.334 187.174 136.707 187.071 137.052 186.866C137.398 186.661 137.673 186.385 137.878 186.04C138.084 185.695 138.186 185.317 138.186 184.906C137.962 184.757 137.687 184.635 137.36 184.542C137.034 184.449 136.688 184.402 136.324 184.402C135.671 184.402 135.176 184.537 134.84 184.808C134.514 185.079 134.35 185.429 134.35 185.858C134.35 186.25 134.5 186.567 134.798 186.81C135.097 187.053 135.475 187.174 135.932 187.174Z",
    fill: "#4B5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3036 175.053C70.085 175.085 69.8664 175.183 69.6842 175.281L64 178.219V185.791L69.7206 188.729C70.7773 189.284 72.0891 188.958 72.7085 188.011C72.8907 187.717 73 187.391 73 187.032V176.946C73 175.738 71.7247 174.759 70.3036 175.053Z",
    fill: "#9AA3B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2319 172H43.7199C41.674 172 40 173.674 40 175.72V188.256C40 190.302 41.674 191.976 43.7199 191.976H59.2319C61.2779 191.976 62.9519 190.302 62.9519 188.256V175.72C62.9519 173.637 61.2779 172 59.2319 172Z",
    fill: "#9AA3B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 184,
    width: 13,
    height: 13,
    rx: 2,
    fill: "#E96351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 188L69 193M64 193L66.5 190.5L69 188",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.832 100H92.2487",
    stroke: "#4B5565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.75 93.583L93.1667 99.9997L86.75 106.416",
    stroke: "#4B5565",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.168 100H43.7513",
    stroke: "#4B5565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.25 93.583L42.8333 99.9997L49.25 106.416",
    stroke: "#4B5565",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123 95.5092C121.522 93.9642 119.428 93 117.105 93C112.629 93 109 96.5817 109 101C109 105.418 112.629 109 117.105 109C119.428 109 121.522 108.036 123 106.491",
    stroke: "#4B5565"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.527 96.2227L123.113 96.1203L123.011 90.5346",
    stroke: "#4B5565",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150 97C150 87.6112 157.611 80 167 80H308V114H167C157.611 114 150 106.389 150 97Z",
    fill: "#BAE0FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 178,
    width: 31,
    height: 12,
    rx: 6,
    fill: "#BAE0FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_724_5524)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 173,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_724_5524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223 97C223 120.748 203.748 140 180 140C156.252 140 137 120.748 137 97C137 73.2518 156.252 54 180 54C203.748 54 223 73.2518 223 97Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_724_5524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 54,
    width: 86,
    height: 86
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 97,
    r: 43,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_724_5524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 97C150 83.1929 161.193 72 175 72H308V122H175C161.193 122 150 110.807 150 97Z",
    fill: "#BAE0FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_724_5524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.167 92.667H171.834C170.906 92.667 170.015 93.0357 169.359 93.6921C168.703 94.3485 168.334 95.2387 168.334 96.167V105.5C168.334 106.429 168.703 107.319 169.359 107.975C170.015 108.632 170.906 109 171.834 109H188.167C189.096 109 189.986 108.632 190.642 107.975C191.299 107.319 191.667 106.429 191.667 105.5V96.167C191.667 95.2387 191.299 94.3485 190.642 93.6921C189.986 93.0357 189.096 92.667 188.167 92.667ZM180.001 103.167C179.539 103.167 179.088 103.03 178.704 102.774C178.321 102.517 178.022 102.153 177.845 101.727C177.668 101.3 177.622 100.831 177.712 100.378C177.802 99.9258 178.024 99.5101 178.351 99.1837C178.677 98.8574 179.093 98.6352 179.545 98.5452C179.998 98.4551 180.467 98.5013 180.894 98.6779C181.32 98.8545 181.684 99.1536 181.941 99.5373C182.197 99.921 182.334 100.372 182.334 100.834C182.334 101.452 182.088 102.046 181.651 102.484C181.213 102.921 180.619 103.167 180.001 103.167Z",
    fill: "#0D121C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 90.3333H184.667V88C184.68 86.7763 184.207 85.5975 183.351 84.7224C182.495 83.8474 181.328 83.3478 180.104 83.3333H180.055C179.445 83.3227 178.839 83.4323 178.272 83.6559C177.705 83.8794 177.187 84.2126 176.749 84.6364C176.31 85.0601 175.959 85.5661 175.717 86.1254C175.474 86.6848 175.344 87.2865 175.333 87.8962V90.3333H173V87.8833C173.019 86.0537 173.758 84.3051 175.057 83.0166C176.356 81.7282 178.111 81.0036 179.941 81H180.012C180.932 80.9983 181.843 81.1787 182.693 81.5307C183.544 81.8828 184.316 82.3996 184.965 83.0513C185.615 83.703 186.129 84.4769 186.478 85.3282C186.827 86.1795 187.005 87.0915 187 88.0117V90.3333Z",
    fill: "#0D121C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_724_5524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.17 153.149L184.164 153.154L184.159 153.16C184.075 153.244 183.875 153.34 183.635 153.34C183.168 153.34 182.789 152.961 182.789 152.496V118.315C182.789 117.693 183.62 117.24 184.19 117.668L208.445 141.391C208.687 141.701 208.705 141.909 208.705 142.013C208.705 142.479 208.326 142.858 207.859 142.858H207.84L207.822 142.859L198.964 143.501L198.269 143.552L198.539 144.194L203.712 156.47L203.713 156.474C203.799 156.674 203.706 156.907 203.505 156.992L203.503 156.992L197.723 159.467C197.67 159.489 197.616 159.5 197.566 159.5C197.518 159.5 197.467 159.491 197.415 159.472C197.319 159.432 197.243 159.356 197.202 159.26L197.202 159.26L197.199 159.253L191.705 146.941L191.418 146.297L190.905 146.782L184.17 153.149Z",
    fill: "white",
    stroke: "#9AA3B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_724_5524",
    x: 0,
    y: 0,
    width: 328.455,
    height: 252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_724_5524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_724_5524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_724_5524",
    x: 237,
    y: 167,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_724_5524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_724_5524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_724_5524",
    x: 117,
    y: 35,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_724_5524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_724_5524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_724_5524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(166 81)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_724_5524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white",
    transform: "translate(174 117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraInstruction);
export default __webpack_public_path__ + "static/media/cameraInstruction.e4f5228b3f6e954b50cb52648c7f1776.svg";
export { ForwardRef as ReactComponent };